import { Stack, Tooltip } from "@mui/material";
import { ReactComponent as IconFlipHorizontal } from "../../../images/flip-h.svg";
import { ReactComponent as IconFlipVertical } from "../../../images/flip-v.svg";
import ToggleIconButton from "../ToggleIconButton";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { useCropperAction } from "@src/v3.0.0/store/cropper/cropper-actions";

function MirrorControl() {
  const {preset, updatePreset} = useCropperStore();
  const {dispatch: dispatchCropperAction} = useCropperAction();
  const onClick = e => {
    // la logica è gestita in react-cropper.jsx
    const value = e.target.dataset.scale;
    const scale = { [value]: preset[value] * -1 };

    updatePreset(scale);
    dispatchCropperAction(scale);
  };
  return (
    <Stack direction={'row'} gap={0.5} alignItems={'center'}>
      <Tooltip title="Specchio orizzontale" placement="top">
        <ToggleIconButton active={preset.scaleX < 0} onClick={onClick} data-scale="scaleX" size="small">
          <IconFlipHorizontal />
        </ToggleIconButton>
      </Tooltip>
      <Tooltip title="Specchio verticale" placement="top">
        <ToggleIconButton active={preset.scaleY < 0} onClick={onClick} data-scale="scaleY" size="small">
          <IconFlipVertical />
        </ToggleIconButton>
      </Tooltip>
    </Stack>
  );
};

export default MirrorControl;